import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { taskLogger } from './lib/taskLogger';
import { initGA } from './lib/analytics';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

// Initialize logging
taskLogger.info('Application started');

// Initialize Google Analytics
initGA();

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);